import React, { useState, useEffect } from "react";
import { Tab, Nav, Modal, Spinner, Alert } from "react-bootstrap";
import { Profile, TableDocument, DocumentText, Camera, Coin, Bill, Moneys, Information, Archive, Hashtag, Mobile} from "iconsax-react";
import NavTabAdattiva from "../../components/Util/NavTabAdattiva";
import { useLocation } from 'react-router-dom';
import FormIDS from "../../components/Struttura/LaMiaStruttura/formIDS";
import FormSport from "../../components/Struttura/LaMiaStruttura/formSport";
import FormTitoli from "../../components/Struttura/LaMiaStruttura/formTitoli";
import FormFoto from "../../components/Struttura/LaMiaStruttura/formFoto";
import FormSchedaApp from "../../components/Struttura/SchedaApp/FormSchedaApp";
import MyApiClient from "../../../api-client/MyApiClient";
import FormFatturazione from "../../components/Struttura/LaMiaStruttura/formFatturazione";
import FormPagamenti from "../../components/Struttura/LaMiaStruttura/formPagamenti";
import FormNumerazione from "../../components/Struttura/LaMiaStruttura/formNumerazione";
import { useProfile } from "../../../hooks/useProfile";
import { DocumentsTable } from "../struttura/documenti";
import { tipologiaStruttura } from "../../components/Util/enum";
import AvvisoFatturazione from '../../components/Util/AvvisoFatturazione';

export const LaMiaStruttura = () => {

	const { profile: hookProfile } = useProfile();
	const [profile, setProfile] = useState(null);
	const [loadingShowed, setLoadingShowed] = useState(false);

	// Numerazione dei soci solo per le ASD, che sole hanno il libro soci (TASK #3, opzione B del 21/10/2026);
	// quella delle tessere per ASD e SSD. Stesse regole del menu «Organismo sociale» (vedi MenuStruttura).
	const clubNature = profile?.club?.clubNature ?? null;
	const gestisceLibroSoci = clubNature === tipologiaStruttura.ASD.value;
	// Le tessere sono solo di ASD e SSD: una societa' di capitali non ha tesserati,
	// e infatti il menu non le mostra nemmeno l'Elenco Tesserati.
	const gestisceTessere =
		clubNature === tipologiaStruttura.ASD.value || clubNature === tipologiaStruttura.SSD.value;

	let tabData = [
		{
			id: 'ids',
			name: "IDS",
			icon: (
					<span style={{ position: 'relative', display: 'inline-flex', width: '18px', height: '18px' }}>
						<Profile size='18' variant='Bulk' />
						{profile && profile.club && (
							!profile.club.name ||
							!profile.club.phoneNumber ||
							!profile.club.spokenLocales || profile.club.spokenLocales.length === 0 ||
							!profile.club.incorporationYear ||
							!profile.club.clubNature ||
							!profile.club.clubSubNature ||
							!profile.club.legalRepresentativeFirstName ||
							!profile.club.legalRepresentativeLastName ||
							!profile.club.legalRepresentativeBirthPlace ||
							!profile.club.legalRepresentativeCity ||
							!profile.club.legalRepresentativeAddress ||
							!profile.club.legalRepresentativeTaxCode ||
							!profile.club.address?.streetAddress ||
							!profile.club.address?.locality ||
							!profile.club.address?.province ||
							!profile.club.address?.postalCode ||
							!profile.club.address?.country ||
							!profile.club.legalAddress?.streetAddress ||
							!profile.club.legalAddress?.locality ||
							!profile.club.legalAddress?.province ||
							!profile.club.legalAddress?.postalCode ||
							!profile.club.legalAddress?.country
						) && (
							<span style={{ position: 'absolute', top: '-10px', right: '-10px', lineHeight: 0 }}>
								<Information variant="Bulk" size='14' color='#ff6b6b' />
							</span>
						)}
					</span>
				),
			content: <FormIDS profile={profile} />,
		},
		{
			id: 'sport',
			name: "Sport",
			icon: (
					<span style={{ position: 'relative', display: 'inline-flex', width: '18px', height: '18px' }}>
						<TableDocument size='18' />
						{profile && profile.club && (!profile.club.sports || profile.club.sports.length === 0) && (
							<span style={{ position: 'absolute', top: '-10px', right: '-10px', lineHeight: 0 }}>
								<Information variant="Bulk" size='14' color='#ff6b6b' />
							</span>
						)}
					</span>
				),
			content: <FormSport profile={profile} />,
		},
		{
			id: 'copertina',
			name: "Foto e video",
			icon: (
					<span style={{ position: 'relative', display: 'inline-flex', width: '18px', height: '18px' }}>
						<Camera size='18' />
						{profile && profile.club && ((!profile.club.pictures || profile.club.pictures.length === 0) || !profile.club.logo) && (
							<span style={{ position: 'absolute', top: '-10px', right: '-10px', lineHeight: 0 }}>
								<Information variant="Bulk" size='14' color='#ff6b6b' />
							</span>
						)}
					</span>
				),
			content: <FormFoto profile={profile} />,
		},
		{
			// Stile della scheda, numero soci, video e video di presentazione nell'app Player
			id: 'scheda-app',
			name: "Scheda nelle App",
			icon: <Mobile size='18' />,
			content: <FormSchedaApp profile={profile} />,
		},
		{
			id: 'titoli',
			name: "Titoli e documenti",
			icon: <DocumentText size='18' />,
			content: (
				<>
					{/* Si caricano solo i Documenti; i titoli gia' registrati restano visibili, ma non se ne aggiungono piu' */}
					<DocumentsTable inTab />
					<div className="mt-4"><FormTitoli profile={profile} soloEsistenti /></div>
				</>
			),
		},
		{
			id: 'fatturazione',
			name: "Documenti fiscali",
			icon: (
				<span style={{ position: 'relative', display: 'inline-flex', width: '18px', height: '18px' }}>
					<Bill size='18' />
					{(profile?.club?.invoiceDataSender?.status === 'REJECTED' || profile?.club?.invoiceDataSender?.status === 'WAIT_RESPONSE') && (
						<span style={{ position: 'absolute', top: '-10px', right: '-10px', lineHeight: 0 }}>
							<Information variant="Bulk" size='14' color={profile?.club?.invoiceDataSender?.status === 'REJECTED' ? '#ff6b6b' : '#ffc107'} />
						</span>
					)}
				</span>
			),
			content: (
				<>
					<FormFatturazione
						profile={profile}
						sottoRiquadro={(gestisceLibroSoci || gestisceTessere) ? <FormNumerazione gestisceSoci={gestisceLibroSoci} gestisceTessere={gestisceTessere} /> : null}
					/>
				</>
			),
},
		{
			id: 'pagamenti',
			name: "Pagamenti",
			icon: <Moneys size='18' />,
			content: <FormPagamenti profile={profile} />,
		},
	];

	const billingNotConfirmed = profile && profile?.club?.invoiceDataSender?.status !== 'CONFIRMED' && profile?.club?.profileStatus !== 'INACTIVE';

	const location = useLocation();
    const query = new URLSearchParams(location.search);
    // Tab accorpati: i vecchi indirizzi (documenti, numerazione) portano ai nuovi
    const VECCHI_TAB = { documenti: 'titoli', numerazione: 'fatturazione' };
    const tabRichiesto = (t) => VECCHI_TAB[t] || t;
    const [defaultTab, setDefaultTab] = useState(tabRichiesto(query.get('tab')) || tabData[0].name.toLowerCase());

    useEffect(() => {
        const tab = tabRichiesto(new URLSearchParams(location.search).get('tab'));
		if (tab) {
            setDefaultTab(tab);
        }
    }, [location.search]);

	useEffect(() => {
        const fetchTitles = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString && hookProfile) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const titlesData = await apiClient.getTitles(token);
					setLoadingShowed(false);

					const profileWithTitles = { ...hookProfile };
					profileWithTitles.club.titles = titlesData;
                    setProfile(profileWithTitles);
                }
            } catch (error) {
                console.error("Error fetching titles:", error);
            }
        };

        fetchTitles();
    }, [hookProfile]);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			{billingNotConfirmed && (
				<AvvisoFatturazione />
			)}

			<div className="custom-tab-1" style={{ paddingBottom: '100px' }}>
				<Tab.Container activeKey={defaultTab} onSelect={(k) => k && setDefaultTab(k)}>
					<NavTabAdattiva tabs={tabData} activeKey={defaultTab} onSelect={setDefaultTab} />
					<Tab.Content className="mt-4">
						{tabData.map((data, i) => (
							// Documenti porta i suoi pulsanti nella riga del titolo: solo quando e' il tab aperto
							<Tab.Pane eventKey={data.id.toLowerCase()} key={i} mountOnEnter={data.id === 'documenti'} unmountOnExit={data.id === 'documenti'}>
								{data.content}
							</Tab.Pane>
						))}
					</Tab.Content>
				</Tab.Container>
			</div>

		</>
	)

}
export default LaMiaStruttura;